import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const exportAdminCardPaymentsReport = async (
    filters: any = {}
): Promise<any> => {
    const sanitized = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== null && v !== undefined))
    const queryParams = FilterBuilder.hashMapToQueryString(sanitized)
    const paramsString = queryParams ? '?' + queryParams : ''
    return await http.get('payment-orders/payments/report' + paramsString)
}
